import { memo } from 'react';
import { LocationMarker } from '@lp/features/RoutePlanner/components/RouteViewList/LocationMarker';
import { SegmentTypeEnum } from '@/api/apis/route';
import { NodeHandleConnections } from './NodeHandleConnections';

export const AltHospitalNode = memo(() => {
  return (
    <NodeHandleConnections>
      <LocationMarker variant="filled" type="end" segmentType={SegmentTypeEnum.hospital} useMonoFont>
        DH
      </LocationMarker>
    </NodeHandleConnections>
  );
});
